import React from "react";

import {
  Box,
  BoxProps,
  Button,
  HStack,
  Input,
  InputGroup,
  InputGroupProps,
  InputRightElement,
  Text,
  Tooltip
} from "@chakra-ui/react";

import { IoCopyOutline } from "react-icons/io5";

import { useCopyToClipboard } from "@/hooks/util/useCopyToClipboard";

export interface ForwardingEmailProps {
  email: string;
  text: string;
  icon?: React.ReactNode;
  containerProps?: BoxProps;
  inputGroupProps?: InputGroupProps;
}

export const ForwardingEmail: React.FC<ForwardingEmailProps> = ({
  email,
  text,
  icon,
  containerProps,
  inputGroupProps
}) => {
  const { handleCopy, copied } = useCopyToClipboard({
    text: email,
    showTooltip: true
  });

  return (
    <Box bg="white" borderRadius={16} px={6} py={4} {...containerProps}>
      <HStack w="full">
        <HStack>
          {icon}
          <Text fontSize={14} fontWeight={500} color="black">
            {text}
          </Text>
        </HStack>
        <InputGroup maxW={410} {...inputGroupProps}>
          <Input
            value={email}
            isReadOnly
            borderRadius="md"
            bg="white"
            minWidth="100px"
            fontWeight={600}
            fontSize={14}
            color="black"
          />
          <InputRightElement
            display="flex"
            alignItems="center"
            justifyContent="center"
            h="full"
          >
            <Tooltip
              label={copied ? "Copied!" : "Copy"}
              isOpen={copied}
              placement="top"
              hasArrow
            >
              <Button
                aria-label="Copy"
                variant="ghost"
                onClick={handleCopy}
                borderRadius="md"
                _hover={{ bg: "blackAlpha.50" }}
                p={2}
                minW={0}
                height="auto"
              >
                <IoCopyOutline />
              </Button>
            </Tooltip>
          </InputRightElement>
        </InputGroup>
      </HStack>
    </Box>
  );
};
